import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'user-collapsible',
  templateUrl: './collapsible.component.html',
  styleUrls: ['./collapsible.component.css']
})
export class CollapsibleComponent {
  isOpen = false;
  @Input() header = "";
}
